module.exports = __webpack_public_path__ + "img/symbol_0.4e288100.png";